export const APP_VERSION = "v0.43.0";
